/* eslint-disable react-hooks/exhaustive-deps */
import { gql, useLazyQuery } from '@apollo/client';
import { ChevronLeftIcon, ChevronRightIcon } from '@chakra-ui/icons';
import { Badge, Box, Button, Center, Flex, Modal, ModalBody, ModalCloseButton, ModalContent, ModalOverlay, Stack, Text, useToast } from '@chakra-ui/react';
import { faFileAlt, faPrint } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
// import { FaChartPie } from 'react-icons/fa';
import ReactPaginate from 'react-paginate';
import { useHistory, useLocation } from 'react-router-dom';
import { Table, Tbody, Td, Th, Thead, Tr } from 'react-super-responsive-table';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import c from '../../../../constant';
import AnnuallyDistributionReportDetail from '../../../../containers/MarketDevelopment/AnnuallyDistributionChannel/detail';
import useStore from '../../../../store';
import { useOpenDetailAs } from '../../../../store/market-data';
import composeQueries from '../../../../utils/composeQueries';
import CompanyName from '../../../CompanyName';
import LabelDate from '../../../LabelDate';
import Filter from '../../../MarketDevelopment/Miscellaneous/filter';
import { CompanyBadge } from '../../../Other';

const Q_REPORTS = gql`
	query get($limit: Float!, $offset: Float!, $companyId: String, $companyType: InsuranceInstitutionsType, $year: Float, $isEditing: Boolean) {
		getAnnuallyDistributionReports(
			pagerInput: { limit: $limit, offset: $offset }
			companyId: $companyId
			companyType: $companyType
			year: $year
			isEditing: $isEditing
		) {
			list {
				id
				company {
					id
					name
					nameKhmer
					type
					logo
				}
				year
				reportType
				createdAt
				isEditing
				editingUpdatedAt
				editingUpdatedBy
				editingDueDate
				editingDescription
				notification {
					read
				}
				penalties {
					id
					active
				}
			}
			totalRows
			totalPages
		}
	}
`;

export default function AnnuallyDistributionList() {
	const toast = useToast();
	const location = useLocation();
	const urlParams = new URLSearchParams(location.search);
	const page = urlParams.get('page') ? urlParams.get('page') : 1;
	const companyId = urlParams.get('companyId') ? urlParams.get('companyId') : null;
	const companyType = urlParams.get('companyType') ? urlParams.get('companyType') : null;
	const year = urlParams.get('year') ? urlParams.get('year') : null;
	const editing = urlParams.has('editing', true);
	const period = urlParams.get('period') || null;
	const reportId = urlParams.get('reportId') || null;
	const { push } = useHistory();
	const { t } = useTranslation();
	const openDetailAs = useOpenDetailAs((state) => state.openDetailAs);
	const [getAnnuallyDistributionReports, { loading: loadingGet, data: dataGet, error: errorGet }] = useLazyQuery(Q_REPORTS, { fetchPolicy: 'no-cache' });
	const readReport = useStore((state) => state.readReport);
	const [detailReportId, setDetailReportId] = useState(undefined);
	const [detailReportType, setDetailReportType] = useState(undefined);

	useEffect(load, [page, companyId, companyType, year, editing]);

	useEffect(() => {
		if (errorGet) {
			if (errorGet?.graphQLErrors?.length > 0) {
				errorGet?.graphQLErrors.map(({ message }, i) =>
					toast({
						title: t(message),
						status: 'error',
						isClosable: true,
						position: 'bottom-right',
					}),
				);
			} else {
				toast({
					title: t(errorGet?.message ? errorGet?.message : 'something went wrong'),
					status: 'error',
					isClosable: true,
					position: 'bottom-right',
				});
			}
		}
	}, [errorGet]);

	function load() {
		const limit = 10;
		const offset = parseInt(page ? (page - 1) * limit : 0) || 0;
		const variables = {
			offset: offset < 0 ? 0 : offset,
			limit,
			companyId,
			companyType,
			year: parseInt(year),
			isEditing: editing ? true : null,
		};
		getAnnuallyDistributionReports({ variables });
	}

	function openDetail(e) {
		e?.notification?.read === false && readReport(reportId);
		if (openDetailAs === 'page') {
			const params = '?id=' + e?.id + '&reportType=' + e?.reportType + '&period=' + period + '&reportId=' + reportId;
			const queries = composeQueries(params, { companyType, companyId });
			push('/market-development-data/annually-distribution-channel-report-for-insurance-company/detail' + queries);
		} else {
			setDetailReportId(e?.id);
			setDetailReportType(e?.reportType);
		}
	}

	return (
		<Center mt="5">
			<Box w="100%" bg="white" borderRadius={c.borderRadius} border="1px solid #dbdbdb" boxShadow="0 1px 2px rgba(var(--black, #000), 0.1)" pb="32px">
				<Flex
					className="hidden-print"
					justifyContent="space-between"
					alignItems="center"
					bg="#FAFAFA"
					p="16px"
					pt="8px"
					pb="8px"
					mb="16px"
					borderBottom="1px solid #dbdbdb"
				>
					<Text flex={{ base: 0, md: 1 }} fontSize="lg" fontWeight="bold" noOfLines={1} display={{ base: 'none', md: 'block' }}>
						{t('Company Report List')}
					</Text>
					<Stack
						flex={{ base: 1, md: 3 }}
						direction={{ base: 'column', md: 'row' }}
						justifyContent="flex-end"
						alignItems="center"
						className="hidden-print"
					>
						{/* <Button
							onMouseDown={() => {
								let params = '?period=' + period + '&reportId=' + reportId;
								push('/market-development-data/annually-distribution-channel-graph' + composeQueries(params, { companyType, companyId }));
							}}
							leftIcon={<FaChartPie />}
							colorScheme="gray"
							variant="solid"
							size="sm"
							borderRadius={c.borderRadius}
							border="1px solid #bdc3c7"
						>
							{t('Graph')}
						</Button> */}
						<Button
							onClick={() => window?.print()}
							leftIcon={<FontAwesomeIcon icon={faPrint} style={{ fontSize: 16 }} />}
							colorScheme="gray"
							variant="solid"
							size="sm"
							borderRadius={c.borderRadius}
							border="1px solid #bdc3c7"
						>
							{t('Print')}
						</Button>
						<Filter
							period={period}
							reportId={reportId}
							companyType={companyType}
							companyId={companyId}
							year={year}
							showMonth={false}
							editing={editing}
							onCallback={(url) => push(`/market-development-data${url}`)}
						/>
					</Stack>
				</Flex>
				{dataGet?.getAnnuallyDistributionReports && (
					<Box p="4" pt="0">
						{loadingGet && (
							<Flex justifyContent="center" alignItems="center">
								<Text>{t('Loading')}</Text>
							</Flex>
						)}
						{!loadingGet && dataGet?.getAnnuallyDistributionReports?.list?.length <= 0 && (
							<Flex direction="column" alignItems="center" justifyContent="center" pt={16} pl={4} pr={4} pb={16}>
								<FontAwesomeIcon icon={faFileAlt} style={{ fontSize: 56, color: '#A0AEC0' }} />
								<Text fontSize="lg" fontWeight="bold" color="gray.600" mt={6}>
									{t('No Data')}
								</Text>
							</Flex>
						)}
						{!loadingGet && dataGet?.getAnnuallyDistributionReports?.list?.length > 0 && (
							<>
								<Table variant="simple" className="table-company-proposal-list responsive-table-container">
									<Thead>
										<Tr className="td-as-th">
											<Th align="left">{t('Company')}</Th>
											<Th align="left">{t('Type')}</Th>
											<Th align="left">{t('Year')}</Th>
											<Th align="left">{t('Submitted At')}</Th>
											<Th align="right">{t('Status')}</Th>
										</Tr>
									</Thead>
									<Tbody>
										{dataGet?.getAnnuallyDistributionReports?.list?.map((e, i) => {
											return (
												<Tr
													key={`report-item-${i}`}
													className={e?.notification?.read === false ? 'new' : 'read'}
													onMouseDown={() => openDetail(e)}
												>
													<Td align="left">
														<CompanyName company={e?.company} />
													</Td>
													<Td align="left">
														<CompanyBadge type={e?.company?.type} />
													</Td>
													<Td align="left">
														<LabelDate input={parseInt(e?.year)} inputFormat="Y" outputFormat="YYYY" />
													</Td>
													<Td align="left">
														<LabelDate input={e?.createdAt} outputFormat={c.dateTimeFormat} />
													</Td>
													<Td align="right">
														{e?.penalties?.length > 0 && (
															<Badge mr={e?.isEditing ? 1 : 0} colorScheme="red" variant="solid">
																{t('Penalized')}
															</Badge>
														)}
														{e?.isEditing ? (
															<Badge colorScheme="orange" variant="solid">
																{t('Editing')}
															</Badge>
														) : (
															<>{e?.penalties?.length > 0 ? <></> : <>-</>}</>
														)}
													</Td>
												</Tr>
											);
										})}
									</Tbody>
									<tfoot className="responsive-footer hidden-print">
										<Tr className="td-as-th">
											<Th align="left">{t('Company')}</Th>
											<Th align="left">{t('Type')}</Th>
											<Th align="left">{t('Year')}</Th>
											<Th align="left">{t('Submitted At')}</Th>
											<Th align="right">{t('Status')}</Th>
										</Tr>
									</tfoot>
								</Table>
								<Flex className="hidden-print" alignItems="flex-end" direction="column" mt={2} pl={6} pr={6}>
									<Text fontSize="sm" fontWeight="semibold" color="gray.600">
										{`${t('Total Rows')}: ${dataGet?.getAnnuallyDistributionReports?.totalRows}`}
									</Text>
								</Flex>
								{dataGet?.getAnnuallyDistributionReports?.totalPages > 1 && (
									<Flex className="hidden-print" justifyContent="flex-end" mt={8} pl={0} pr={0}>
										<ReactPaginate
											previousLabel={<ChevronLeftIcon fontSize="20px" />}
											nextLabel={<ChevronRightIcon fontSize="20px" />}
											breakLabel={'...'}
											breakClassName={'break-me'}
											disableInitialCallback={true}
											pageCount={dataGet?.getAnnuallyDistributionReports?.totalPages}
											marginPagesDisplayed={2}
											pageRangeDisplayed={3}
											onPageChange={({ selected }) => {
												let page = selected + 1;
												let url = '?period=' + period + '&reportId=' + reportId + '&page=' + page;
												if (companyId !== null && companyId !== undefined) {
													url += `&companyId=${companyId}`;
												}
												if (companyType !== null && companyType !== undefined) {
													url += `&companyType=${companyType}`;
												}
												if (year !== null && year !== undefined) {
													url += `&year=${year}`;
												}
												if (editing !== null && editing !== undefined) {
													url += `&editing=${editing}`;
												}
												push(`/market-development-data${url}`);
											}}
											containerClassName={'pagination'}
											activeClassName={'active'}
											initialPage={(page - 1) | 0}
										/>
									</Flex>
								)}
							</>
						)}
					</Box>
				)}
			</Box>
			{detailReportId && detailReportType && (
				<Modal
					size="full"
					isOpen={true}
					onClose={() => {
						setDetailReportId(undefined);
						setDetailReportType(undefined);
					}}
				>
					<ModalOverlay />
					<ModalContent borderRadius={c.borderRadius}>
						<ModalCloseButton />
						<ModalBody>
							<AnnuallyDistributionReportDetail detailReportId={detailReportId} detailReportType={detailReportType} />
						</ModalBody>
					</ModalContent>
				</Modal>
			)}
		</Center>
	);
}
